import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import BasePage from "@Scripts/Pages/BasePage";
import Axios from "axios";

export default class GlobalBikeProductDetailPage extends BasePage {
    public static async init() {
        await super.init();

        this.setCompatibility();
        this.setGallery();
    }

    private static setCompatibility() {
        let buttons = document.querySelectorAll(".show-all-compatibility .button");
        let application = document.querySelectorAll(".product-application");
        let success = document.querySelectorAll(".success-compatibility");
        for (const button of buttons) {
            if (button.classList.contains("hden")) {
                button.classList.remove("hden");
            }
            application.forEach(item => {
                item.classList.add("hden");
            });
            success.forEach(item => {
                item.classList.add("hden");
            });
        }
    }

    private static setGallery() {
        new (<any>window).Carousel(document.getElementById("Carousel"), {
            infinite: false,
            Dots: false,
            transition: "slide"
        });

        (<any>window).Fancybox.bind("[data-fancybox='gallery']", {
            dragToClose: false,
            Images: {
                zoom: true,
            },
            Toolbar: {
                display: {
                    left: [],
                    middle: [],
                    right: ['close'],
                },
            },
            Thumbs: {
                type: 'classic',
            },
        });
    }
}